import { defaultIdDisplayed } from "./../../shared/data";
import { TranslateService } from "@ngx-translate/core";
import { Helper } from "./../../shared/helper";
import { Component, OnInit, Input } from "@angular/core";
import { FilterOptionService } from "app/features/filter-options/filter-options.service";
import { ToasterService } from "app/shared";
import { City } from "app/features/filter-options/city";
import {
  OnChanges,
  OnDestroy
} from "@angular/core/src/metadata/lifecycle_hooks";
import { DataInteraction, Year } from "app/shared/data-interaction";
import * as uikit from "uikit";
import { Subscription } from "rxjs";
import { DataCollectionService } from "app/shared/services/data-collection.service";
import { DashSelectionService } from "app/shared/services/dash-selection.service";
import { PassThrough } from "stream";

@Component({
  selector: "app-filter-options",
  templateUrl: "./filter-options.component.html",
  styleUrls: ["./filter-options.component.scss"]
})
export class FilterOptionsComponent implements OnInit, OnChanges, OnDestroy {
  @Input("expanded") expanded;
  @Input() isDashboard;
  @Input() listOfFilterValuesToDisplay: {};
  @Input() ascYearsOPtion;

  private _region: City;
  private _cities: City[] = [];
  years: Year[] = [];
  yearsSubscription?: Subscription;

  private _buttonsValues;
  private _buttonsValuesSimple;
  private _buttonsIndicators;
  private _buttonsMoneySavedCO2;
  private _buttonsIndicatorsVehicles;
  private _buttonsEnergy;
  private _buttonsEnergyServForBdg;
  private _buttonsEnergyType;
  private _buttonsPerimeter;
  private _buttonsNetworksInd;
  private _buttonsVehicleFuels;
  private _buttonsVehicleTypes;
  private _buttonsActionCategory;
  private _buttonsSiaAssignment;
  private _buttonsEnergeticAgent;
  private _buttonsScopesSectors;
  private _buttonsGhgScopes;
  private _buttonsEmissionSectors;
  private _selectedCity;
  private nbEmissionsSectors = [];
  selectedYear;
  private _multiCity;
  private _initialDashboard; // just used to get the initial kpis displayed to get the correct years

  constructor(
    private dataCollectionService: DataCollectionService,
    private filterOptionsService: FilterOptionService,
    private toasterService: ToasterService,
    private helper: Helper,
    private translateService: TranslateService,
    private dashSelectionService: DashSelectionService
  ) {
    this._initialDashboard = dashSelectionService
      .getSelectedDashboard()
      .getValue();

    this.yearsSubscription = this.filterOptionsService
      .getYears()
      .subscribe(data => {
        if (data) {
          // update years list
          this.years = data;

          // check if selected year is available in the new list
          const currentYear = this.years.filter(
            year =>
              this.selectedYear && year.objectId == this.selectedYear.objectId
          );

          if (currentYear.length > 0) {
            // reassign same year => allows to refresh select view
            this.selectedYear = currentYear[0];
          } else {
            // update with default selected year
            let selectedYearIdx = 0;
            if (!this.ascYearsOPtion) {
              selectedYearIdx = this.years.length - 1;
            }
            this.selectedYear = this.years[selectedYearIdx];
            this.filterOptionsService.setYear(this.selectedYear, true);
          }
        }
      });
  }

  ngOnDestroy(): void {
    // remove subscriptions
    this.yearsSubscription.unsubscribe();
  }

  get selectedCity() {
    return this._selectedCity;
  }
  get cities() {
    return this._cities;
  }
  get region() {
    return this._region;
  }
  get buttonsValues() {
    return this._buttonsValues;
  }
  get buttonsValuesSimple() {
    return this._buttonsValuesSimple;
  }
  get buttonsMoneySavedCO2(){
    return this._buttonsMoneySavedCO2
  }
  get buttonsIndicators() {
    return this._buttonsIndicators;
  }
  get buttonsIndicatorsVehicles(){
    return this._buttonsIndicatorsVehicles;
  }
  get buttonsEnergy() {
    return this._buttonsEnergy;
  }
  get buttonsEnergyServForBdg() {
    return this._buttonsEnergyServForBdg;
  }
  get buttonsEnergyType() {
    return this._buttonsEnergyType;
  }
  get buttonsPerimeter() {
    return this._buttonsPerimeter;
  }
  get buttonsNetworkInd() {
    return this._buttonsNetworksInd;
  }
  get buttonsVehicleFuels() {
    return this._buttonsVehicleFuels;
  }
  get buttonsVehicleTypes() {
    return this._buttonsVehicleTypes;
  }
  get buttonsActionCategory() {
    return this._buttonsActionCategory;
  }
  get buttonsSiaAssignment() {
    return this._buttonsSiaAssignment;
  }
  get buttonsEnergeticAgent() {
    return this._buttonsEnergeticAgent;
  }
  get buttonsScopesSectors() {
    return this._buttonsScopesSectors;
  }
  get buttonsGhgScopes() {
    return this._buttonsGhgScopes;
  }
  get buttonsEmissionSectors() {
    return this._buttonsEmissionSectors;
  }
  set selectedCity(s) {
    this._selectedCity = s;
  }

  ngOnInit() {
    this.dataCollectionService.getConfigFile().then(data => {
      this._multiCity = data.multiCity;
      // setup year filter only here because we need config file to get kpis
      const kpiNamesFromConfig = data["dashboards"][this._initialDashboard][
        "kpis"
      ].map(kpi => kpi.id);
      const yearFilter = data["dashboards"][this._initialDashboard][
        "filters"
      ].filter(filter => filter.filterName == "yearSelector");

      let kpiNames = kpiNamesFromConfig; // default use year from kpis
      let desiredYears = [];
      let descendingOrder = undefined;
      // check if user configured the values for the years
      if (data["dashboards"][this._initialDashboard]["filters"].length == 0){
        console.log('NO FILTER');
      } else if (yearFilter && yearFilter[0]["filterValue"]) {
        descendingOrder = yearFilter[0]["filterValue"]["descending"];
        // use hard coded years and ignor kpis if provided
        if (yearFilter[0]["filterValue"]["years"]) {
          kpiNames = [];
          desiredYears = yearFilter[0]["filterValue"]["years"];
        }
      }

      this.filterOptionsService.updateYears(
        kpiNames,
        this._selectedCity,
        desiredYears,
        descendingOrder
      );

      this.initFilters();
    });
  }

  ngOnChanges(changes) {
    if (
      !!changes.isDashboard &&
      changes.isDashboard.firstChange &&
      this.isDashboard === true
    ) {
      this.filterOptionsService.setAllCharts();
      this.filterOptionsService.setFilters();
    }
  }
  initFilters() {
    this.filterOptionsService.getRegion().then((res: any) => {
      this._region = res.results[0];
      // use get + subscribe to translate region, because translation is probably not loaded yet and instant() does not work
      this.translateService.get("DASHBOARD.CHARTS.REGION").subscribe(val => {
        this._region["name"] = val;
      });

      this.filterOptionsService.getCities().then((res: any) => {
        // setup cities filter
        let tempCities = res.results;
        // add region to list of cities if desired
        if (this.isRegionDisplayed()) {
          tempCities.push(this._region);
        }
        this._cities = this.filterOptionsService.setCities(tempCities);
        this._selectedCity = this.cities.filter(
          x => x.objectId === defaultIdDisplayed
        )[0];
        this.onCitySelect(false);

        // setup filters with buttons
        this._buttonsValues = this.filterOptionsService.getButtonsValueType();
        this._buttonsIndicators = this.filterOptionsService.getButtonsIndicator();
        this._buttonsMoneySavedCO2 = this.filterOptionsService.getButtonsMoneyOrCO2();
        this._buttonsIndicatorsVehicles = this.filterOptionsService.getButtonsIndicatorVehicles();
        this._buttonsEnergy = this.filterOptionsService.getButtonsEnergyService();
        this._buttonsEnergyServForBdg = this.filterOptionsService.getButtonsEnergyServiceForBdg();
        this._buttonsEnergyType = this.filterOptionsService.getButtonsEnergyType();
        this._buttonsPerimeter = this.filterOptionsService.getButtonsPerimeter();
        this._buttonsNetworksInd = this.filterOptionsService.getButtonsNetworksInd();
        this._buttonsVehicleFuels = this.filterOptionsService.getButtonsVehicleFuel();
        this._buttonsVehicleTypes = this.filterOptionsService.getButtonsVehicleType();
        this._buttonsActionCategory = this.filterOptionsService.getButtonsActionCategory();
        this._buttonsSiaAssignment = this.filterOptionsService.getButtonsSiaAssignment();
        this._buttonsEnergeticAgent = this.filterOptionsService.getButtonsEnergeticAgent();
        this._buttonsScopesSectors = this.filterOptionsService.getButtonsScopesSectors();
        this._buttonsGhgScopes = this.filterOptionsService.getButtonsGhgScopes();
        this._buttonsEmissionSectors = this.filterOptionsService.getButtonsGhgEmissionSectors();

        // update chart data globally
        this.filterOptionsService.setAllCharts();

        // set the default filter values
        this.filterOptionsService.setDefaultFilterValues(
          this.listOfFilterValuesToDisplay,
          true
        );
      });
    });
  }

  numberOfButtonsDisplayed(filterId) {
    let numberOfButtons = 0;

    switch (filterId) {
      case "typeOfValue":
        this.buttonsValues.forEach(button => {
          numberOfButtons += this.isButtonDisplayed(filterId, button.id)
            ? 1
            : 0;
        });
        break;

      case "energyService":
        this.buttonsEnergy.forEach(button => {
          numberOfButtons += this.isButtonDisplayed(filterId, button.id)
            ? 1
            : 0;
        });

      case "siaAssignment":
        this.buttonsSiaAssignment.forEach(button => {
          numberOfButtons += this.isButtonDisplayed(filterId, button.id)
            ? 1
            : 0;
        });

      case "energetic_agent":
        this.buttonsEnergeticAgent.forEach(button => {
          numberOfButtons += this.isButtonDisplayed(filterId, button.id)
            ? 1
            : 0;
        });
      
      case "ghg_scopes":
        this.buttonsGhgScopes.forEach(button => {
          numberOfButtons += this.isButtonDisplayed(filterId, button.id)
            ? 1
            : 0;
          });
    }

    return numberOfButtons;
  }

  isButtonDisplayed(filterId, buttonId) {
    let isDisplayed = false;
    const valuesToDisplay = this.listOfFilterValuesToDisplay[filterId];
    // Check that values to display for the requested filter is defined
    // for now the test is needed because the config file is not yet updated for all filters.
    if (valuesToDisplay) {
      if (Object.keys(valuesToDisplay).includes(buttonId)) {
        isDisplayed = true;
      }
    }
    return isDisplayed;
  }

  isFilterDisplayed(filterId) {
    let isDisplayed = false;
    const filtersToDisplay = Object.keys(this.listOfFilterValuesToDisplay);
    // Check that values to display for the requested filter is defined
    // for now the test is needed because the config file is not yet updated for all filters.
    if (filtersToDisplay.includes(filterId)) {
      isDisplayed = true;
    }
    return isDisplayed;
  }

  isRegionDisplayed() {
    let isDisplayed = false;

    // check if comparison filter is displayed
    if (this.isFilterDisplayed("compareCitiesFromRegion")) {
      const filterValue = this.listOfFilterValuesToDisplay[
        "compareCitiesFromRegion"
      ];
      // check if region must be display in filter
      if (Object.keys(filterValue).includes("regionSelection")) {
        isDisplayed = true;
      }
    }

    return isDisplayed;
  }

  // SETTER
  setValueType(id) {
    this.filterOptionsService.setValueType(id);
  }
  setIndicator(id) {
    this.filterOptionsService.setIndicator(id);
  }
  setMoneyOrCO2(id){
    this.filterOptionsService.setMoneyOrCO2(id);
  }
  setIndicatorVehicles(id) {
    this.filterOptionsService.setIndicatorVehicles(id);
  }
  setPerimeter(id) {
    this.filterOptionsService.setPerimeter(id);
  }
  setNetworksInd(id) {
    this.filterOptionsService.setNetworksInd(id);
  }
  setVehicleFuels(id) {
    this.filterOptionsService.setVehicleFuels(id);
  }
  setVehicleTypes(id) {
    this.filterOptionsService.setVehicleTypes(id);
  }
  setActionCategory(id) {
    this.filterOptionsService.setActionCategory(id);
  }
  setSiaAssignment(id) {
    this.filterOptionsService.setSiaAssignment(id);
  }
  setEnergeticAgent(id) {
    this.filterOptionsService.setEnergeticAgent(id);
  }
  setGhgScopesSectors(id){
    this.filterOptionsService.setGhgScopesSectors(id);
  } 
  setGhgScopes(id){
    this.filterOptionsService.setGhgScopes(id);
  }
  setGhgEmissionSectors(id){
    this.nbEmissionsSectors = this.filterOptionsService.setGhgEmissionSectors(id);
  }
  /* setTimelineValue(timeline) {
    this.filterOptionsService.setTimelineValue(timeline);
  } */
  onYearSelect() {
    this.filterOptionsService.setYear(this.selectedYear);
  }
  onCitySelect(update_global_data = true) {
    this.filterOptionsService.resetCitySelected();
    const selectedCity = this.filterOptionsService.getCity(
      this.selectedCity.objectId
    );
    selectedCity.selected = true;
    selectedCity.toCompare = false;
    if (update_global_data) {
      this.filterOptionsService.setAllCharts();
      this.filterOptionsService.dataFiltersNext();
    }
  }
  getTooltipTranslated(id, translateId) {
    uikit
      .tooltip("#" + id, {
        title: this.translateService.instant(translateId),
        pos: "right"
      })
      .show();
  }
  selectToCompare(city) {
    city.toCompare = !city.toCompare;
    this.filterOptionsService.selectToCompare(city);
  }

  setEnergyService(button) {
    this.filterOptionsService.setEnergyService(button);
  }

  setEnergyServiceBdg(button) {
    this.filterOptionsService.setEnergyServiceBdg(button);
  }

  setEnergyType(button) {
    this.filterOptionsService.setEnergyType(button);
  }
}
